import type { NavigationUrls } from 'types';

export const getRecordDetailUrl = (urls: NavigationUrls, recordId: string): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}/r/${recordId}/detail`;
};

export const getAgendaListUrl = (urls: NavigationUrls): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}`;
};

export const getEditRecordUrl = (urls: NavigationUrls, recordId: string): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}/r/${recordId}`;
};

export const getHeliosRecordDetailUrl = (moduleId: string, templateId: string, recordNumber: number | string): string => {
  return `/user/modules/${moduleId}/Helios/${templateId}/r/${recordNumber}/detail`;
};
